






















import { Vue, Component } from 'vue-property-decorator';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import { v4 as uuidv4 } from 'uuid';
import AccountingReportTable from '@accounting/components/tables/accounting-report/accounting-report-table.vue';

@Component({
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bc-accounting-report-table': AccountingReportTable,
  },
})
export default class AccountingReportsPage extends Vue {
  // PROPS
  // DATA
  // LIFECYCLE
  // created(){}
  // mounted(){}
  // updated(){}
  // destroyed(){}
  // COMPUTED
  get actionsPortalTarget() {
    return `accounting-reports-actions-${uuidv4()}`;
  }
  get navigationPortalTarget() {
    return `accounting-reports-navigation-${uuidv4()}`;
  }
  // METHODS
  // WATCHERS
}
